/* eslint-disable guard-for-in */
/* eslint-disable no-continue */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable consistent-return */

import { readStore } from '../mobx/stores/rf';
import operatorInfo from '../conf/operator';

/**
 * @description 检测是否是DOM对象
 * @export
 * @returns {boolean}
 */
export function isElement(obj) {
  return obj instanceof HTMLElement;
}

/**
 * @description 空函数
 * @export
 */
export function noop() {}

/**
 * @description 对象是否包含某个属性
 * @export
 * @param {object} obj
 * @param {string} key
 * @returns {boolean}
 */
export function objectHasOwnProperty(obj, key) {
  return Object.hasOwnProperty.call(obj, key);
}

/**
 * @description 循环执行一个方法
 * @export
 * @param {object}
 * @property {number} [interval=300] 执行间隔
 * @property {number} [max=1] 最大执行次数
 * @property {function} fn 执行函数
 * @property {function} errorFn 超过次数的错误函数
 * @returns {timerID}
 */
export function loopExecuteFn({
  interval = 3000,
  max,
  executeFn = noop,
  errorFn = noop
}) {
  let count = 0;
  let timer = null;

  (function loopExecute() {
    count += 1;

    // 超出最大重试次数，中断操作
    const exceed = max !== undefined
      && max !== null
      && count > max;

    if (exceed) {
      return errorFn(count);
    }

    try {
      // 原生接口不存在或者调用出错,中断操作
      const result = executeFn();
      if (result instanceof Error) {
        return errorFn(count, '执行异常');
      }
    } catch (error) {
      console.log(error);
      return errorFn(count, '执行异常');
    }

    timer = setTimeout(() => {
      loopExecute();
    }, interval);
  }());

  return {
    count: () => {
      return count;
    },
    stop: () => {
      clearTimeout(timer);
      timer = null;
    }
  };
}

/**
 * @description 串行执行Promise数组
 * @export
 * @param {array} myPromises
 */
export function runPromiseByQueue(myPromises) {
  return myPromises.reduce(
    (previousPromise, nextPromise) => {
      return previousPromise
        .then(() => {
          return nextPromise();
        });
    },
    Promise.resolve()
  );
}

/**
 * @description 统一为命令添加结束标记（添加转义字符，保证给到原生未丢失）
 * @export
 * @param {string} command
 * @returns {string}
 */
export function formatCommand(command) {
  return `${command}\\r\\n`;
}

/**
 * @description 统一为命令添加结束标记(不添加转义字符)
 * @export
 * @param {string} command
 * @returns {string}
 */
export function formatCommandNoEscape(command) {
  return `${command}\r\n`;
}

/**
 * @description 命令不足4个字节或者4个字节的倍数自动补全0
 * @export
 * @param {string} command
 * @returns {string}
 */
export function autoCompleteCommand(command) {
  // eslint-disable-next-line prefer-destructuring
  const length = command.length;
  const completeNum = 4 - (length < 4 ? length : (length % 4 || 4));
  return command + String.prototype.repeat.call('0', completeNum);
}

/**
 * @description 从数组中随机一个子项返回
 * @export
 * @param {Array} arr
 * @returns
 */
export function selectRandomFromArr(arr) {
  return arr.splice(parseInt(Math.random() * arr.length, 10), 1);
}

/**
 * @description 格式化日期
 * @export
 * @param {Date|string} time
 * @param {'date'|'time'|'datetime'|undefined} type
 * @returns
 */
export function formatDateTime(time, type) {
  const date = time instanceof Date ? time : new Date(time);
  if (!date) return;

  const y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? (`0${m}`) : m;
  let d = date.getDate();
  d = d < 10 ? (`0${d}`) : d;
  let h = date.getHours();
  h = h < 10 ? (`0${h}`) : h;
  let minute = date.getMinutes();
  minute = minute < 10 ? (`0${minute}`) : minute;
  let sec = date.getSeconds();
  sec = sec < 10 ? (`0${sec}`) : sec;

  const dateStr = `${y}-${m}-${d}`;
  const timeStr = `${h}:${minute}:${sec}`;

  switch (type) {
    case 'date':
      return dateStr;
    case 'time':
      return timeStr;
    case 'timeHM':
      return `${h}:${minute}`;
    case 'datetime':
    default:
      return `${dateStr} ${timeStr}`;
  }
}

/**
 * @description 格式化地磁传输的时间
 * 地磁上的时间是从 2018/01/01 00:00:00 开始计算的秒数
 * @export
 * @param {number|string} time
 * @returns {string} 'yyyy-MM-dd hh:mm:ss'
 */
export function formatGeoTime(time) {
  const start = new Date('2018/01/01 00:00:00');
  const res = +start + parseInt(time, 10) * 1000;
  return formatDateTime(new Date(res));
}

/**
 * @description 字符串转16进制
 * @export
 * @param {string} str
 * @returns {string}
 */
export function stringToHex(str) {
  let val = '';
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < str.length; i++) {
    const hex = str.charCodeAt(i).toString(16);
    val += hex.length === 1 ? `0${hex}` : hex;
  }

  return val.toUpperCase();
}

/**
 * @description 带符号十六进制字符串转十进制
 * @export
 * @param {string} hex e.g. 'FFAC' -> -84
 * @returns 十进制数
 */
export function hexToDecimal(hex) {
  const a = parseInt(hex, 16);

  // 根据符号位判断正负，负数的话符号位为1，则走反码加1取反的操作
  if (a >> 15) {
    // 清除符号位
    const b = a & 0x7FFF;
    // 取反码
    const c = ~b;
    // 清除左边多余位
    let d = c & 0x7FFF;
    d += 1;
    return d * -1;
  }

  return a;
}

export function stringToBinary(str) {
  const binary = [];

  for (let i = 0; i < str.length; i++) {
    const bia = str.charCodeAt(i).toString(2);
    binary.push(bia);
  }

  return binary;
}

/**
 * @description 将发卡器返回的16进制字符串切割成2个一组的数组
 * @param {string} hex
 * @returns {Array}
 */
function splitHex(hex) {
  return hex.split(/(.{2})/).filter(item => !!item);
}

/**
 * @description 十六进制无前缀‘0x’转十进制
 * @param {string} hex
 * @returns
 */
function hex2Decimal(hex) {
  return parseInt(`0x${hex}`, 16);
}

/**
 * @description 16进制转字符串
 * @export
 * @param {string} hex
 * @returns {string}
 */
export function hexToString(hex) {
  const hexArr = splitHex(hex);
  let result = '';

  hexArr.forEach((item) => {
    result += String.fromCharCode(hex2Decimal(item));
  });

  return result;
}

/**
 * @description 十六进制转八位二进制字符串
 * @export
 * @param {string} hex
 * @returns
 */
export function hexToBinaryString(hex) {
  let binary = parseInt(hex, 16).toString(2);
  const len = binary.length;
  if (len < 8) {
    for (let index = 0; index < 8 - len; index++) {
      binary = 0 + binary;
    }
  }

  return binary;
}

/**
 * @description 将字符串切割成等分的数组
 * @export
 * @param {string} str
 * @param {number} num
 * e.g. splitStringNumber('123456', 2) -> ['12', '34', '56']
 * @returns
 */
export function splitStringNumber(str, num) {
  const reg = new RegExp(`(\\w{${num}})`);
  return str.split(reg).filter(Boolean);
}

/**
 * @description 32位十六进制转二进制
 * @export
 * @param {string} hex
 * 具体计算过程可查看：https://wenku.baidu.com/view/380cc770964bcf84b9d57bac.html
 */
export function hexToFloat(hex) {
  const bStr = splitStringNumber(hex, 2)
    .map(item => hexToBinaryString(item))
    .join('');

  // 第1位为符号位
  const sign = bStr[0] === '0' ? 1 : -1;
  // 2-9位是指数部分，float占8位，double占11位，并且float指数部分偏移量为127，double是1023
  const exponent = parseInt(bStr.substr(1, 8), 2) - 127;
  // 其余位数为小数位，具体算法：需要加上隐含的小数点前面的1
  const mantissa = bStr.substr(9);
  let decimal = 1 * (2 ** 0);

  for (let index = 0; index < mantissa.length; index++) {
    decimal += mantissa[index] * (2 ** (-1 - index));
  }

  return (sign * decimal * (2 ** exponent)).toFixed(2);
}

const COMMUNICATE_TYPES = {
  1: {
    title: 'NB'
  },
  2: {
    title: 'LORA'
  },
  3: {
    title: 'LORAJP' // 光感地磁日本LoRa版
  }
};

/**
 * @description 获取通讯类型
 * @param {number} type
 * @returns
 */
function getCommunicate(type) {
  return type in COMMUNICATE_TYPES ? COMMUNICATE_TYPES[type].title : '';
}

/**
 * @description 获取运营商
 * @param {number} type
 * @returns
 */
function getOperator(type) {
  const operator = operatorInfo[Number(type)];
  if (!operator) {
    return '';
  }
  return operator.desc;
}

// 地磁检测类型
const DETECT_OPERATE = {
  geo: {
    name: '地磁',
    title: 'geo',
    operate: '0x01' // 按位与操作值，结果为1则第一位的类型为true
  },
  radar: {
    name: '雷达',
    title: 'radar',
    operate: '0x02'
  },
  optical: {
    name: '光感',
    title: 'optical',
    operate: '0x04'
  }
};

/**
 * @description 获取检测类型
 * @param {string} hex
 * @returns
 */
function getDetectType(hex) {
  const hexStr = `0x${hex}`;
  const result = [];

  Object.keys(DETECT_OPERATE).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(DETECT_OPERATE, key)) {
      const item = DETECT_OPERATE[key];
      result.push({
        value: !!(hexStr & item.operate),
        ...item
      });
    }
  });

  return result;
}

/**
 * @description 从十六进制字符串中解析项目参数
 * @export
 * @param {string} hex
 * @returns {object}
 */
export function parseProjParam(hex) {
  const hexArr = splitHex(hex);
  if (hexArr.length < 4) {
    return false;
  }

  const majorVersion = hex2Decimal(hexArr[0]);
  const minorVersion = hex2Decimal(hexArr[1]);
  const operateArr = hexArr[2].split('');
  const communicateType = hex2Decimal(operateArr[0]);
  const operator = hex2Decimal(operateArr[1]);
  const detectType = hexArr[3];
  const version = `${majorVersion}.${minorVersion}`;

  console.log('项目参数解析：', hex, hexArr, communicateType, operator, getOperator(operator));

  return {
    version: {
      origin_value: version,
      value: version
    },
    communicateType: {
      origin_value: communicateType,
      value: getCommunicate(communicateType)
    },
    operator: {
      origin_value: operator,
      value: communicateType === 2 ? '' : getOperator(operator)
    },
    detectType: {
      origin_value: detectType,
      value: getDetectType(detectType)
    },
  };
}

/**
 * @description 16进制字符串转为字符串
 * @export
 * @param {string} hex 16进制字符串
 * @returns
 */
export function parseHexToStr(hex) {
  const hexArr = splitHex(hex);
  const decimalArr = hexArr.map(hex2Decimal);
  return String.fromCharCode(...decimalArr);
}

/**
 * @description 反序列化查询参数，引用自：https://github.com/AceMetrix/jquery-deparam/blob/master/jquery-deparam.js
 * @export
 * @param {string} params
 * @param {boolean} coerce
 * @returns {object} 反序列化后的对象
 */
export function deparam(params, coerce, seprate) {
  const obj = {};
  // eslint-disable-next-line camelcase
  const coerce_types = {
    true: !0,
    false: !1,
    null: null
  };

  // If params is an empty string or otherwise falsy, return obj.
  if (!params) {
    return obj;
  }

  // Iterate over all name=value pairs.
  params.replace(/\+/g, ' ').split(seprate || '&').forEach((v) => {
    const param = v.split('=');
    let key = decodeURIComponent(param[0]);
    let val;
    let cur = obj;
    let i = 0;

    // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
    // into its component parts.
    let keys = key.split('][');
    let keys_last = keys.length - 1;

    // If the first keys part contains [ and the last ends with ], then []
    // are correctly balanced.
    if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
      // Remove the trailing ] from the last keys part.
      keys[keys_last] = keys[keys_last].replace(/\]$/, '');

      // Split first keys part into two parts on the [ and add them back onto
      // the beginning of the keys array.
      keys = keys.shift().split('[').concat(keys);

      keys_last = keys.length - 1;
    } else {
      // Basic 'foo' style key.
      keys_last = 0;
    }

    // Are we dealing with a name=value pair, or just a name?
    if (param.length === 2) {
      val = decodeURIComponent(param[1]);

      // Coerce values.
      if (coerce) {
        val = val && !Number.isNaN(val) && ((`${+val}`) === val) ? +val // number
          : val === 'undefined' ? undefined // undefined
            : coerce_types[val] !== undefined ? coerce_types[val] // true, false, null
              : val; // string
      }

      if (keys_last) {
        // Complex key, build deep object structure based on a few rules:
        // * The 'cur' pointer starts at the object top-level.
        // * [] = array push (n is set to array length), [n] = array if n is
        //   numeric, otherwise object.
        // * If at the last keys part, set the value.
        // * For each keys part, if the current level is undefined create an
        //   object or array based on the type of the next keys part.
        // * Move the 'cur' pointer to the next level.
        // * Rinse & repeat.
        for (; i <= keys_last; i++) {
          key = keys[i] === '' ? cur.length : keys[i];
          // eslint-disable-next-line no-multi-assign
          cur = cur[key] = i < keys_last
            ? cur[key] || (keys[i + 1] && Number.isNaN(keys[i + 1]) ? {} : [])
            : val;
        }
      } else {
        // Simple key, even simpler rules, since only scalars and shallow
        // arrays are allowed.

        // eslint-disable-next-line no-lonely-if
        if (Object.prototype.toString.call(obj[key]) === '[object Array]') {
          // val is already an array, so push on the next value.
          obj[key].push(val);
        } else if ({}.hasOwnProperty.call(obj, key)) {
          // val isn't an array, but since a second value has been specified,
          // convert val into an array.
          obj[key] = [obj[key], val];
        } else {
          // val is a scalar.
          obj[key] = val;
        }
      }
    } else if (key) {
      // No value was defined, so set something meaningful.
      obj[key] = coerce ? undefined : '';
    }
  });

  return obj;
}

/**
 * @description 获取访问url里所带参数
 * @export
 * @param {string} name
 * @returns
 */
export function getUrlParam(name) {
  const search = window.location.search.substr(1);
  const params = deparam(search);
  return name ? params[name] : params;
}

/**
 * @description 对象数组深拷贝
 * @export
 * @param {object|array} p
 * @param {object|array} c
 * @returns
 */
export function deepCopy(p, c) {
  const nc = c || {};
  // eslint-disable-next-line no-restricted-syntax
  for (const i in p) {
    if (p[i] !== null && typeof p[i] === 'object') {
      nc[i] = p[i].constructor === Array ? [] : {};
      deepCopy(p[i], nc[i]);
    } else {
      nc[i] = p[i];
    }
  }
  return nc;
}

/**
 * @description 音频播放
 * @export
 * @param {string} url 音频地址
 * @returns
 */
export const playAudio = (function playAudio() {
  let audio = null;
  let oldUrl = '';
  let same = false;

  return function (url) {
    if (!audio) {
      audio = document.createElement('audio');
      audio.style.display = 'none';
      document.body.appendChild(audio);
    }

    // 先暂停原音频
    audio.pause();

    if (url === oldUrl) {
      same = true;
    } else {
      oldUrl = url;
      audio.src = url;
      audio.play();
      same = false;
    }

    return {
      same,
      destroy: () => {
        audio.pause();
        audio.remove();
      }
    };
  };
}());

/**
* @description 判断是否是对象，排除null，来自于underscore
* @param {any} obj
* @returns
*/
export function isObject(obj) {
  return obj === Object(obj);
}


/**
 * @description 获取对象多层属性值，key可以嵌套多层 ‘message.code’
 * @param {object} obj
 * @param {string} keys
 */
export function getObjMultiLevelValue(obj, keys) {
  if (!isObject(obj)) return null;

  const keyArr = keys.split('.');
  let value = obj;

  try {
    keyArr.forEach((key) => {
      if (!isObject(value)) {
        throw new Error('end');
      }
      if (key in value) {
        value = value[key];
      } else {
        throw new Error('end');
      }
    });
  // eslint-disable-next-line no-empty
  } catch (error) {}

  return value;
}

// 退出安装调试界面
export function quit() {
  window.location.reload();
  // window.history.back();
}

export function debounce(fn, delayTime) {
  let timeId;
  return function (...args) {
    const context = this;
    // eslint-disable-next-line no-unused-expressions
    timeId && clearTimeout(timeId);
    timeId = setTimeout(() => {
      fn.apply(context, args);
    }, delayTime);
  };
}

/**
 * @description 页面无操作监听
 * @export
 * @param {number} timeout 超时时间 单位：ms
 * @param {function} [callback=noop] 页面无操作回调
 */
export function noOperateDone(timeout, callback = noop) {
  let timer = null;
  function timeoutFn() {
    // eslint-disable-next-line no-unused-expressions
    timer && clearTimeout(timer);
    timer = null;
    timer = setTimeout(() => {
      callback();
    }, timeout);
  }

  timeoutFn();

  document.body.ontouchstart = debounce(timeoutFn, 400);
  document.body.onmousemove = debounce(timeoutFn, 400);
}

/**
 * @description 时间差转换为文字
 * @export
 * @param {number} time
 * @returns
 */
export function transformTime(time, en) {
  // 计算出相差天数
  let days = Math.floor(time / (24 * 3600 * 1000));
  // 计算出小时数
  const leave1 = time % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000));
  // 计算相差分钟数
  const leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000));
  // 计算相差秒数
  const leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
  let seconds = Math.round(leave3 / 1000);
  const dayDesc = en ? 'd' : '天';
  const hDesc = en ? 'h' : '小时';
  const mDesc = en ? 'm' : '分钟';
  const sDesc = en ? 's' : '秒';
  days = days > 0 ? `${days}${dayDesc}` : '';
  hours = hours > 0 ? `${hours}${hDesc}` : '';
  minutes = minutes > 0 ? `${minutes}${mDesc}` : '';
  seconds = seconds > 0 ? `${seconds}${sDesc}` : '';
  return days + hours + minutes + seconds;
}

/**
 * @description 从给定的模组中根据地磁检测方式筛选可操作的模组
 * @export
 * @param {array} modules
 * @returns
 */
export function filterDetectModules(modules) {
  const targets = [...modules];
  const detectType = [];

  readStore.getProjParam('detectType').forEach((item) => {
    if (item.value) {
      detectType.push(item.title);
    }
  });

  // 筛选出不存在的检测类型
  const filterDT = Object.values(DETECT_OPERATE)
    .map(item => item.title)
    .filter(item => detectType.indexOf(item) < 0);

  return targets.filter(item => filterDT.indexOf(item) < 0);
}

/**
 * @description 从给定的模组中根据地运营商筛选可操作的模组
 * @export
 * @param {array} modules
 * @returns
 */
export function filterOperatorModules(modules) {
  const targets = [...modules];

  // 筛选出不存在的通讯类型
  const filterCT = Object.values(COMMUNICATE_TYPES)
    .map(item => item.title.toLowerCase())
    .filter(item => item !== readStore.communicateType);

  return targets.filter(item => filterCT.indexOf(item) < 0);
}

// 创建一个包含code和count的Error类
export function createError(msg, code, count) {
  const error = new Error(msg);
  if (code !== undefined) error.code = code;
  if (count !== undefined) error.count = count;
  return error;
}

// 比较两个版本号大小，v1大于v2则为真，否则为假
export function compareVersion(v1, v2) {
  if (!v1 || !v2) return false;
  const left = v1.split('.');
  const right = v2.split('.');
  const maxLen = left.length > right.length ? left.length : right.length;
  let flag = false;

  for (let index = 0; index < maxLen; index++) {
    const item = parseFloat(left[index]);
    const item1 = parseFloat(right[index]);
    if (item >= 0 && item1 >= 0 && item !== item1) {
      flag = item > item1;
      break;
    }
  }

  return flag;
}

export function compareArray(arr1, arr2) {
  // if the other array is a falsy value, return
  if (!arr1 || !arr2) return false;
  // compare lengths - can save a lot of time
  if (arr1.length !== arr2.length) return false;

  for (let i = 0, l = arr1.length; i < l; i++) {
    // Check if we have nested arrays
    if (arr1[i] instanceof Array && arr2[i] instanceof Array) {
      // recurse into the nested arrays
      if (!compareArray(arr1[i], arr2[i])) return false;
    } else if (arr1[i] instanceof Object && arr2[i] instanceof Object) {
      // eslint-disable-next-line no-use-before-define
      if (!compareObject(arr1[i], arr2[i])) return false;
    } else if (arr1[i] !== arr2[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
}

export function compareObject(obj1, obj2, forceLeft) {
  // eslint-disable-next-line no-param-reassign
  forceLeft = forceLeft !== false;
  if (forceLeft) {
    // For the first loop, we only check for types
    // eslint-disable-next-line no-restricted-syntax
    for (const propName in obj1) {
      // Check for inherited methods and properties - like .equals itself
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/hasOwnProperty
      // Return false if the return value is different
      if (obj1.hasOwnProperty(propName) !== obj2.hasOwnProperty(propName)) {
        return false;
      } if (typeof obj1[propName] !== typeof obj2[propName]) {
        // Different types => not equal
        return false;
      }
    }
  }

  // Now a deeper check using other objects property names
  // eslint-disable-next-line no-restricted-syntax
  for (const propName in obj2) {
    // We must check instances anyway, there may be a property that only exists in obj2
    // I wonder, if remembering the checked values from the first loop would be faster or not
    if (obj1.hasOwnProperty(propName) !== obj2.hasOwnProperty(propName)) {
      return false;
    } if (typeof obj1[propName] !== typeof obj2[propName]) {
      return false;
    }
    // If the property is inherited, do not check any more (it must be equa if both objects inherit it)
    if (!obj1.hasOwnProperty(propName)) continue;
    // Now the detail check and recursion
    // obj1 returns the script back to the array comparing
    /** REQUIRES Array.equals * */
    if (obj1[propName] instanceof Array && obj2[propName] instanceof Array) {
      // recurse into the nested arrays
      if (!compareArray(obj1[propName], obj2[propName])) return false;
    } else if (obj1[propName] instanceof Object && obj2[propName] instanceof Object) {
      // recurse into another objects
      // console.log("Recursing to compare ", obj1[propName],"with",obj2[propName], " both named \""+propName+"\"");
      if (!compareObject(obj1[propName], obj2[propName])) return false;
    } else if (obj1[propName] !== obj2[propName]) {
      // Normal value comparison for strings and numbers
      return false;
    }
  }
  // If everything passed, let's say YES
  return true;
}

/**
 * @description 限制事件在outTime的时间内连续触发maxCount次后才执行一次，e.g. 连续点击5次后触发
 * @export
 * @param {function} fn
 * @param {number} [maxCount=5]
 * @param {number} [outTime=1000]
 * @returns
 */
export function countEventTrigger(fn, maxCount = 5, outTime = 2000) {
  if (typeof fn !== 'function') {
    console.error('countEventTrigger的第一个参数必须是函数');
  }
  let count = 0;
  let timer = null;
  function reset() {
    count = 0;
    clearTimeout(timer);
    timer = null;
  }

  return function (...args) {
    count++;
    if (timer) {
      if (count >= maxCount) {
        reset();
        fn.apply(this, args);
      }
    } else {
      timer = setTimeout(() => {
        reset();
      }, outTime);
    }
  };
}

export function getCookie(name) {
  const arr = document.cookie.split('; ');
  for (let i = 0; i < arr.length; i++) {
    const arrName = arr[i].split('=');
    if (arrName[0] === name) {
      return arrName[1];
    }
  }
  return '';
}

export function isPureObject(obj) {
  return (typeof obj === 'object' && !Array.isArray(obj) && obj !== null);
}

/**
 * @description 判断是否是空对象
 * @export
 * @param {object} e
 * @returns
 */
export function isEmptyObject(e) {
  if (!isPureObject(e)) {
    return false;
  }
  return Object.keys(e).length === 0;
}


/**
 * @description 解析蓝牙命令结果
 * @export
 * @param {string} data .e.g rsrp=60\r\ntxpow=10\r\nsinr=5\r\necl=0\r\npci=166\r\ncellid=83583617
 * @param {string} name
 * @returns
 */
export function formatBtCmdResult(data, name) {
  console.log(data);
  const params = deparam(data, false, '\r\n');
  console.log(params);
  return name ? params[name] : params;
}

/**
 * @description 指定函数执行count次
 * @param {number} count
 * @param {function} fn
 */
export function executeFnByCount(count, fn) {
  let num = count;
  do {
    fn(num);
  } while (--num);
}

/**
 * @description 删除数组中的元素
 * @export
 * @param {array} arr
 * @param {function} func 控制是否删除元素，返回值为布尔值
 * @returns
 */
export function dropElements(arr, func) {
  return arr.filter(item => !func(item));
}

export function getRadarState(state) {
  const map = {
    0: '无车',
    1: '有车',
    2: '覆盖',
    3: '很乱',
    4: '很远',
    5: '未开'
  };

  return map[state];
}
